import apiClient from './apiClient';
import useAdminLoginStore from '../stores/adminLogin';

// 요청 인터셉터 등록
export function setupRequestInterceptor() {
    apiClient.interceptors.request.use(
        config => {
            return config;
        },
        error => {
            // 요청 에러 처리
            console.error('요청 중 에러 발생:', error.message);
            return Promise.reject(error);
        },
    );
}

// 응답 인터셉터 등록
export function setupResponseInterceptor() {
    apiClient.interceptors.response.use(
        response => {
            // 응답 데이터 전처리
            return response;
        },
        error => {
            // 응답 에러 처리
            if (error.response) {
                // 서버 응답이 있는 경우
                if (error.response.status === 401) {
                    console.warn('인증 실패: 재로그인 필요');
                    const hostname = window.location.hostname;
                    if (
                        hostname.endsWith('admin.inbody.dev') ||
                        hostname.endsWith('admin.beta.inbody.dev') ||
                        hostname.endsWith('admin.test.inbody.dev')
                    ) {
                        const adminLoginStore = useAdminLoginStore();
                        adminLoginStore.clearToken();
                    }
                } else if (error.response.status === 500) {
                    console.error('서버 오류 발생');
                }
            } else if (error.request) {
                // 요청은 보냈으나 응답을 받지 못한 경우 (CORS 포함)
                console.error('요청이 전송되었으나 응답이 없습니다. (네트워크 문제 또는 CORS)');
                // CORS 에러라면 error.message에 'Network Error' 나옴
                if (error.message && error.message.includes('Network Error')) {
                    console.error('CORS 정책 위반 또는 네트워크 차단 가능성');
                }
            } else {
                // 요청 자체가 만들어지지 않은 경우
                console.error('요청 설정 중 오류 발생:', error.message);
            }

            return Promise.reject(error);
        },
    );
}
